<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '数据集'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="5vh"
    :close-on-click-modal="false">
    <el-form :model="item" ref="itemform" label-width="100px" :rules="rules">
      <el-form-item label="数据集名称" prop="Name">
        <el-input v-model.trim="item.Name" placeholder="请输入数据集名称"></el-input>
      </el-form-item>
      <el-form-item label="数据集编号" prop="Taxo">
        <el-input v-model.trim="item.Taxo" placeholder="请输入数据集编号"></el-input>
        <span class="text-muted">即数据中的'$taxo'的值</span>
      </el-form-item>
      <el-form-item label="显示优先级" prop="Priority">
        <el-input-number v-model="item.Priority"></el-input-number>
        <span class="pad-l-md">数字越小越靠前显示</span>
      </el-form-item>
      <el-form-item label="显示创建时间" prop="ShowTime">
        <el-switch v-model="item.ShowTime"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit"
        :disabled="submitting || !item.Name || !item.Taxo">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      rules: {
        Name: [
          { required: true, message: '数据集名称不能为空', trigger: 'blur' },
        ],
        Taxo: [
          { required: true, message: '数据集编号不能为空', trigger: 'blur' },
        ],
      },
      submitting: false,
    };
  },
  methods: {
    onOpen() {
      this.item = _.clone(this.value);
    },
    onClose() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) return;
        this.submitting = true;
        this.$emit('input', this.item);
        const itemData = {
          ID: this.item.ID,
          Name: this.item.Name,
          Taxo: this.item.Taxo,
          Priority: this.item.Priority ? this.item.Priority : 0,
          ShowTime: this.item.ShowTime,
        };
        // 保存的操作
        this.$axios.request({
          url: this.item.ID ? `category/${itemData.ID}` : 'category',
          method: itemData.ID ? 'put' : 'post',
          data: itemData,
        }).then(() => {
          this.$message.success(itemData.ID ? '成功修改数据集' : '成功添加数据集');
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', true);
          this.$emit('form:saved', true);
          this.$emit('update:visible', false);
        }).catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.submitting = false;
          this.$emit(itemData.ID ? 'form:updated' : 'form:created', false);
          this.$emit('form:saved', false);
        });
      });
    },
  },
};
</script>
